// Yoonly FR overrides — only keys that differ from the regular FR translations.

import { getCgvLink, getDataRightsLink, getPrivacyPolicyLink } from "@/service/legalLinks/legalLinksService";
import { OptionsTranslations } from "./optionsTranslations.types";

// Missing keys automatically fall back to the standard 'fr' locale.
const dataRightsLink = getDataRightsLink("fr");
const privacyPolicyLink = getPrivacyPolicyLink("fr");

const optionsYoonlyFrTranslations: any = {
    optionsPage: {},
    "optin": {
        "terms": {
            "short": "Les données recueillies sont traitées par Yoonly qui est le responsable du traitement et dont le siège est situé au 19 rue Emmy Noether, 93400 Saint-Ouen, France. <br/>",
            "full":
                `Ces données sont indispensables pour gérer votre réservation, et conclure le contrat relatif. 
         Elles seront intégrées dans la base de données de Yoonly et également utilisées pour vous adresser des informations et des publicités
          sur des produits et services similaires sur la base notamment de notre intérêt légitime et des dispositions légales en matière de prospection.
           Vous disposez de droits sur vos données que vous pouvez exercer via notre formulaire de contact disponible <a href='${dataRightsLink}' target='_blank'>ici</a>. Pour en savoir plus sur le
            traitement de vos données, consultez notre <a href='${privacyPolicyLink}' target='_blank'>politique de protection des données personnelles</a>.
         Vous pourrez également vous désinscrire à tout moment via un lien dans les newsletters électroniques, ou par courrier électronique.`
        }

    },
};

export default optionsYoonlyFrTranslations;
